import { render, staticRenderFns } from "./SimulateStimulate.vue?vue&type=template&id=4f650e10&scoped=true&"
import script from "./SimulateStimulate.vue?vue&type=script&lang=js&"
export * from "./SimulateStimulate.vue?vue&type=script&lang=js&"
import style0 from "./SimulateStimulate.vue?vue&type=style&index=0&id=4f650e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f650e10",
  null
  
)

export default component.exports